
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SelectAchievementQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"achievement"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"achievement"},"value":{"kind":"Variable","name":{"kind":"Name","value":"achievement"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenpo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievementSteps"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement_step"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_step_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_step_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"counting_condition"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"closing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"index"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievementStepMediums"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement_step_medium"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_step"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"baitai_id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"achievementStepActions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement_step_action"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_step"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action_type"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"achievementStepIntermediaries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement_step_intermediary"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"achievement_step"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"intermediary_type"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"achievementOutputOptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_user"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order_number"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shop_user"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":832}};
    doc.loc.source = {"body":"query SelectAchievementQuery($achievement: Int!) {\n  achievement(achievement: $achievement) {\n    achievement\n    tenpo\n    achievement_name\n    achievement_type\n    achievementSteps{\n      achievement_step\n      achievement\n      achievement_step_name\n      achievement_step_type\n      counting_condition\n      closing\n      index\n      achievementStepMediums{\n        achievement_step_medium\n        achievement_step\n        baitai_id\n      }\n      achievementStepActions{\n        achievement_step_action\n        achievement_step\n        action_type\n      }\n      achievementStepIntermediaries{\n        achievement_step_intermediary\n        achievement_step\n        intermediary_type\n      }\n    }\n    achievementOutputOptions {\n      achievement\n      created_at\n      created_user\n      order_number\n      shop_user\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SelectAchievementQuery"] = oneQuery(doc, "SelectAchievementQuery");
        
